import Vue from "vue";
import VueLazyload from "vue-lazyload";

export default () => {
  Vue.use(VueLazyload, {
    observer: true,
    dispatchEvent: true,
  });
};
